module.exports = __webpack_public_path__ + "img/blue-checkmark.e54da879.svg";